const prefix = '@intl';

// Action types
export const LOCALE_CHANGE = `${prefix}/LOCALE_CHANGE`;
